export default __webpack_public_path__ + "static/media/en-logo.07e9c1ba.svg";